export default __webpack_public_path__ + "static/admin-identity-bg-f0e726131460c5320bf53e667f481c54.png";